import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resetScrollPosition } from './resetScrollPosition';

const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    resetScrollPosition();

    const frameId = window.requestAnimationFrame(() => {
      resetScrollPosition();
    });

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, [location.pathname, location.search, location.key]);

  return null;
};

export default ScrollToTop;
